<div class="outerwrap" fxLayout="column" fxLayoutAlign="start stretch">
    <h1 mat-dialog-title>{{title}}</h1>
    <div class="scroll" fxFlex>
        <div [innerHTML]="message | safeHTML"></div>
        <div>
            <form [formGroup]="proxyForm" novalidate>
                <div>
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start stretch">
                        <mat-form-field floatLabel="never">
                            <input matInput class="parentname advisorsearch" type="text" formControlName="ParentName" placeholder="Enter parent/guardian name..." />
                        </mat-form-field>
                        <mat-form-field floatLabel="never">
                            <mat-select class="parentselect" formControlName="ParentType" placeholder="Select parent/guardian type" aria-label="Parent / Guardian Type Select List">
                                <mat-option *ngFor="let ptype of ParentTypes" [value]="ptype">{{ptype.Description}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field *ngIf="ParentType.value && ParentType.value.RequiresNote === true">
                            <input matInput type="text" class="advisorsearch" formControlName="ParentTypeNote" placeholder="Enter relationship..." />
                        </mat-form-field>
                    </div>
                    <mat-checkbox *ngIf="statement" formControlName="Checked" aria-label="Confirmation Checkbox">
                        <span [innerHTML]="statement | safeHTML"></span>
                    </mat-checkbox>            
                </div>
            </form>
        </div>
    </div>
    <div class="actionbar" fxLayout="row" fxLayoutAlign="end center" fxLayoutGap="15px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center">
        <button mat-raised-button color="primary" [disabled]="proxyForm.invalid" (click)="OKHandler()"><span [innerHTML]="oktext | safeHTML"></span></button>
        <button mat-raised-button color="warn" (click)="CancelHandler()"><span [innerHTML]="canceltext | safeHTML"></span></button>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/services/dialogs/proxyapprove/proxyapprove.dialogcomponent.html